export const NavbarDetails = [
  {
    title: "Home",
    url: "/",
  },
  {
    title: "About",
    url: "/about",
  },
  {
    title: "Dashboard",
    url: "/dashboard",
  },
  {
    title: "Library",
    url: "/library",
  },
];

export const NavbarAuthButton = [
  {
    title: "Login",
    url: "/login",
  },
  {
    title: "Register",
    url: "/register",
  },
];
